import type {KanbanSortBy} from '@dms/api/core';
import i18n from '@dms/i18n';

export function getKanbanSortOptions(): {value: KanbanSortBy; label: string}[] {
  return [
    {
      value: 'CREATED_AT_DESC',
      label: i18n.t('page.opportunitiesKanban.settings.sortByCreatedAtDesc'),
    },
    {
      value: 'CREATED_AT_ASC',
      label: i18n.t('page.opportunitiesKanban.settings.sortByCreatedAtAsc'),
    },
    {
      value: 'LAST_ACTIVITY_ASC',
      label: i18n.t('page.opportunitiesKanban.settings.sortByLastActivityAsc'),
    },
    {
      value: 'LAST_COMMUNICATION_ASC',
      label: i18n.t('page.opportunitiesKanban.settings.sortByLastCommunicationAsc'),
    },
  ];
}
